import MobileMenu from '@components/ui/mobile-menu/mobile-menu';
export default MobileMenu;
